import React, { Component } from 'react';
import { Form, Modal, Input, message } from 'antd';
import { getConfigEdit } from '../../../apis/api'

const FormItem = Form.Item

class systemEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmLoading: false,
    }
  }

  componentWillMount() {}

  componentDidMount(){}

  componentWillUnmount() {
    // 在卸载的时候对所有的操作进行清除
    this.setState = (state, callback) => {
      return;
    };
  }

  doSubmit = () => {
    const  { form, recordList } = this.props;

    form.validateFields((err,value)=>{
      if(!err){

        let params = {
          access_token: sessionStorage.getItem('access_token'),
          id: recordList && recordList.id,
          name: value.name,
          model: value.model,
        };

        this.setState({
          confirmLoading: true
        })

        getConfigEdit(params).then( (data)=> {
          if(data.code === 0){

            message.success("操作成功");
            this.props.doSearch();
            this.props.handleCancel();

            this.setState({
              confirmLoading: false
            })

          } else {
            message.error(data.message);
            this.setState({
              confirmLoading: false
            })
          }
        }).catch(err => {

          this.setState({
            confirmLoading: false
          })

        });
      }
    })
  }
  render() {
    const { confirmLoading, } = this.state;
    const { form, visible, recordList } = this.props;
    const { getFieldDecorator } = form; //用于表单进行双向数据绑定
    const formItemLayout = {
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 18,
      },
    };
    return (
      <Modal 
        className="systemModal"
        title="添加应用系统"
        visible={visible} 
        confirmLoading = {confirmLoading}
        destroyOnClose = {true}
        width={600}
        onOk={this.doSubmit}
        onCancel={this.props.handleCancel}
        okText="确定"
        cancelText="取消"
      >
        <div className="layout_content_wrapper">
        <Form>
          <FormItem 
            {...formItemLayout}
            label="系统名称:" 
            className="formItem"
          >
            {
              getFieldDecorator('name',{
                initialValue: recordList.name,
                rules: [
                  {required: true, message: '请输入系统名称'},
                ]
              })(
                <Input allowClear placeholder="请输入系统名称"/>
              )
            }
          </FormItem>

          <FormItem 
            {...formItemLayout}
            label="模型名称:" 
            className="formItem"
          >
            {
              getFieldDecorator('model',{
                initialValue: recordList.model,
                rules: [
                  {required: true, message: '请输入模型名称'},
                ]
              })(
                <Input allowClear placeholder="请输入模型名称" />
              )
            }
          </FormItem>
      </Form>
        </div>
      </Modal>
      
    );
  }
}

const systemEditForm = Form.create()(systemEdit);
export default systemEditForm;


// WEBPACK FOOTER //
// ./src/page/LogManagement/components/systemEdit.js